export default {
  dbi_intelligence: '情报',
  dbi_confirm: '确定',
  dbi_no_filter_changes: '筛选条件未修改',
  dbi_note: '通知',
  dbi_cancel: '取消',
  dbi_back: '后退',
  dbi_reset: '重置',
  dbi_more_filter: '更多筛选器',
  dbi_collapse_filter: '折叠筛选器',
  dbi_filter_show: '展开',
  dbi_actions: '操作',
  dbi_more: '更多',
  dbi_details: '详情',
  dbi_sortby: '排序依据',
  dbi_please_select: '请选择',
  dbi_follow: '关注',
  dbi_following: '已关注',
  dbi_detail_follow: '加入关注',
  dbi_detail_following: '已关注',
  dbi_menu_following: '关注的游戏',
  dbi_pie_chart: '饼状图',
  dbi_bar_chart: '柱状图',
  dbi_line_chart: '折线图',
  dbi_world_map_chart: '地图',
  dbi_stacked_line_chart: '堆叠折线图',
  dbi_tree_map: '矩形树图',
  dbi_disabled_chart_tips: '当前可视化不适用于该指标',
  dbi_sorted_by: '按{sortData}排序',
  dbi_date: '日期',
  dbi_value: '数值',
  dbi_time: '时间',
  dbi_all_select: '全选',
  dbi_all: '全部',
  dbi_day: '日',
  dbi_week: '周',
  dbi_month: '月',
  dbi_hour: '时',
  dbi_hour_tooltip: '因数据量较大，Steam Hourly CCU 不支持超过7天时间周期展示',
  dbi_days: '日',
  dbi_weeks: '周',
  dbi_months: '月',
  dbi_daily: '日',
  dbi_weekly: '周',
  dbi_monthly: '月',
  dbi_quarterly: '季',
  dbi_annually: '年',
  dbi_game: '游戏',
  dbi_search_result: '搜索结果',
  dbi_game_selection: '游戏选择',
  dbi_select_games: '选择游戏',
  dbi_game_lower: '游戏',
  dbi_games: '游戏',
  dbi_no_data_please_add: '无数据，请添加',
  dbi_key_metrics: '关键指标',
  dbi_search_any_game: '搜索任何游戏',
  dbi_Choose_up_to_games: '最多能选',
  dbi_Choose_up_to_games_end: '款游戏',
  dbi_search_any_company: '搜索任何公司',
  dbi_please_a_select_game: '请选择游戏',
  dbi_please_a_select_company: '请选择公司',
  dbi_no_search_results: '没有搜索结果',
  dbi_menu_search_page_group: '页面',
  dbi_add: '添加',
  dbi_operation_successfully_tips: '操作成功!',
  dbi_operation_failly_tips: '操作失败，请重试。',
  // 统一 operation 提示
  dbi_common_operation_succeed_tips: '操作成功！',
  dbi_common_operation_failed_tips: '操作失败！',
  dbi_download_settings: '下载设置',
  dbi_source_quality: '数据源质量',
  dbi_alinea_release_to_be_decided: '待定',
  dbi_alinea_release_upcoming: '即将上线',
  dbi_download_title_tips: '你可以选择聚合或拆分方式来展示当前筛选条件下的数据。',
  dbi_download: '下载',
  dbi_label_summary: '摘要',
  dbi_label_financials: '财务状况',
  dbi_label_people: '人员',
  dbi_label_metrics: '指标',
  dbi_label_metrics_category: '指标类型',
  dbi_label_visualization_metrics: '可视化指标',
  dbi_label_palyform_Setting: '平台设置',
  dbi_download_tips:
    '按时间划分法：将返回按日粒度划分的数据。聚合方法：将返回带有当前过滤器的数据。显示数据： 当前页面的所有行。',
  dbi_jumpdashboard_modal_tips:
    '您目前访问的是第三方情报数据，您有这款游戏的经分权限，是否帮您直接跳转经分查看真实数据？',
  dbi_goto_dashboard: 'OK! 进入经分',
  dbi_stay_intelligence: 'NO, 留在情报',
  dbi_no_prompt_again: '不再提示',
  dbi_no_show_again: '不再提示',
  dbi_filters_redirect_tips_title: '跳转至对应筛选条件？',
  dbi_filters_redirect_tips_desc1: '将跳转至{metricInfo}的对应筛选条件，',
  dbi_filters_redirect_tips_desc2: '时间筛选器的时间粒度和时间范围可能会改变。',
  dbi_tip: '提示',
  dbi_label_basic_info: '基本信息',
  dbi_label_basic_info_optional: '基本信息(可选的)',
  dbi_label_release_date: '发行日期',
  dbi_label_company_info: '公司信息',
  dbi_label_genre: '游戏类型',
  dbi_label_data_calculation: '数据计算',
  dbi_label_data_calculation_change: '数据计算变化',
  dbi_label_data_settings: '数据设置',
  dbi_label_time_settings: '时间设置',
  dbi_label_platform_settings: '平台设置',
  dbi_label_anchors_settings: '主播设置',
  dbi_label_game_settings: '游戏设置',
  dbi_label_time_settings_tips: '活跃用户指标有不同的粒度，选择以下选项可获得 DAU/WAU/MAU。',
  dbi_label_chart: '图表',
  dbi_label_rankings: '榜单',
  dbi_label_aggregated: '聚合',
  dbi_label_separate_by_time: '按时间划分',
  dbi_label_separate_by_platform: '按平台划分',
  dbi_label_show_top_influencers: '展示头部网红',
  dbi_label_separate_by_games: '按游戏划分',
  dbi_label_edition_settings: '版本设置',
  dbi_label_separate_by_edition: '按版本划分',
  dbi_label_region_settings: '区域设置',
  dbi_label_country_settings: '国家设置',
  dbi_label_genre_settings: '品类设置',
  dbi_label_segment_settings: '商业化部分设置',
  dbi_label_segment_settings_product: '产品分类设置',
  // dbi_label_npd_device_settings: '设备设置（NPD）',
  // dbi_label_famitsu_device_settings: '设备设置（Famitsu）',
  // dbi_label_gsd_device_settings: '设备设置（GSD）',
  // dbi_label_mscience_device_settings: '设备设置（Mscience）',
  dbi_label_device_settings: '平台设置',
  dbi_label_npd_device_settings: '平台设置（NPD）',
  dbi_label_famitsu_device_settings: '平台设置（Famitsu）',
  dbi_label_gsd_device_settings: '平台设置（GSD）',
  dbi_label_mscience_device_settings: '平台设置（Mscience）',
  dbi_label_separate_by_country: '按国家分隔',
  dbi_label_separate_by_region: '按区域分隔',
  // dbi_label_separate_by_device: '按设备划分',
  // dbi_label_separate_by_device_combine: '分设备',
  dbi_label_separate_by_device_combine: '分平台',
  dbi_label_separate_by_segment_combine: '分产品分类',
  dbi_label_separate_by_time_combine: '分日期',
  dbi_label_separate_by_country_combine: '分国家',
  dbi_label_separate_by_region_combine: '分区域',
  dbi_label_separate_by_genres: '按品类分隔',
  dbi_label_separate_by_sub_genres: '按副品类分隔',
  dbi_label_ratio: '比例',
  dbi_label_data_amount: '数据量',
  dbi_export_all_data: '导出所有数据',
  dbi_export_all_tip: '最多下载10万行',
  dbi_select_top: '选择前几名',
  dbi_label_download_type: '下载类型',
  dbi_download_type_by_game: '按游戏查看时间趋势',
  dbi_download_type_by_game_tip: '一个游戏在不同时间段的榜单变化',
  dbi_download_type_by_time: '按时间查看榜单变动',
  dbi_download_type_by_time_tip: '特定时间段内各游戏的榜单表现',
  dbi_export_checked_lines: '导出所选数据',
  dbi_select_top_over_maximum_value: '· 超过最大值',
  dbi_select_top_must_more_than_one: '· 必须大于一',
  dbi_download_max_value_tip: '该筛选条件下，最多可下载的游戏总数为{maxValue}',
  dbi_label_file_format: '文件格式',
  dbi_label_excel: 'Excel',
  dbi_label_csv: 'CSV',
  dbi_label_other_settings: '其他设置',
  dbi_mobile_games: '手游',
  dbi_mobile_games_pc: '三端互通',
  dbi_mobile_combine: '三端互通',
  dbi_pc_games: '端游',
  dbi_console_games: '主机游戏',
  dbi_pcconsole_games: '端游 & 主机游戏',
  dbi_company_games: '公司',
  dbi_total_games: '游戏汇总',
  dbi_device: '设备',
  dbi_device_dimension_data_unavailable: '无设备维度数据',
  dbi_company: '公司',
  dbi_company_lower: '公司',
  dbi_source: '数据源',
  dbi_data_source: '数据源',
  'Data Source': '数据源',
  dbi_platform: '平台',
  Platform: '平台',
  dbi_platform_ios: 'iOS',
  dbi_platform_android: 'Android',
  dbi_platform_unified: '统一',
  dbi_platform_wechat: '微信',
  dbi_platform_douyin: '抖音',
  'Segment For Sales': '产品分类',
  dbi_digitalARPPU_desc: `请注意， MScience US Digital ARPPU($) 选择1个或”全部“产品分类。<br/>
定义：ARPPU= 收入 / 去重付费用户总数。由于隐私保护，MScience不提供单个payer购买的详细产品列表，DataBrain 无法进行用户去重。因此多个产品分类的ARPPU比实际值偏小。
举例：某天游戏A有1个用户购买游戏本体消费20美元，商店内消费50美元。则游戏本体ARPPU为20美元，MTX ARPPU为50美元，实际游戏本体+MTX的ARPPU为70美元，但由于无法去重用户，计算的ARPPU为（50+20）/（1+1）=35美元。<br/>
当产品分类选择“全部”时，MScience提供去重付费用户总数，因此数据可参考。`,
  dbi_publisher: '发行商',
  dbi_product_list: '产品列表',
  dbi_product_list_total_count: '共 {count} 个产品',
  dbi_product_list_total_count_singular: '共 {count} 个产品',
  dbi_publisher_hover_tip: '点击查看该公司的产品列表',
  dbi_publisher_class: '发行商规模',
  dbi_publisher_class_hobbyist: '个人及爱好者发行',
  dbi_publisher_class_indie: '独立发行',
  dbi_publisher_class_aa: 'AA级发行',
  dbi_publisher_class_aaa: '3A级发行',
  dbi_publisher_region: '发行商国家',
  dbi_developer: '开发商',
  dbi_main_genre: '主品类',
  dbi_sub_genre: '副品类',
  dbi_super_genre: '游戏分类',
  dbi_level_1_genre: '一级品类',
  dbi_level_2_genre: '二级品类',
  dbi_level_3_genre: '三级品类',
  dbi_level_4_genre: '四级品类',
  dbi_main_sub_genre: '主品类+副品类',
  dbi_genre_category: '品类类别',
  dbi_game_platform: '游戏平台',
  dbi_game_add: '添加',
  dbi_success_follow: '收藏成功!',
  dbi_failed_follow: '收藏失败，请再尝试一次。',
  dbi_top10_revenue: '收入前十的游戏',
  dbi_top10_pheat: '潜力值前十的游戏',
  dbi_top10_digital: '线上收入前十的游戏',
  dbi_top10_sum_rev: '总收入前十公司',
  dbi_type_games_only: '(这里只能搜索{type})',
  dbi_revenue_setting: '收入设置',
  dbi_revenue_range_unit_setting: '收入区间设置',
  dbi_physical_revenue_setting: '零售收入设置',
  dbi_premium_revenue_setting: 'Steam本体收入设置',
  dbi_pcu_setting: 'PCU设置',
  dbi_price_setting: 'Steam价格设置',
  dbi_premium_revenue_range: 'Steam付费游戏本体收入区间',
  dbi_digital_revenue_setting: '线上收入设置',
  dbi_revenue_range: '收入区间',
  dbi_revenue_range_unit: '收入区间（美元）',
  dbi_arpu_range: 'ARPU区间',
  dbi_active_users_range: '活跃区间',
  dbi_downloads_range: '下载区间',
  dbi_rpd_range: 'RPD区间',
  dbi_d2_range: 'D2区间',
  dbi_d3_range: 'D3区间',
  dbi_d7_range: 'D7区间',
  dbi_d15_range: 'D15区间',
  dbi_d31_range: 'D31区间',
  dbi_revenue_scope_excluding_store_fees: '收入剔除佣金',
  dbi_revenue_scope_including_store_fees: '收入包含佣金',
  dbi_revenue_scope_exclude_store_fees: '收入剔除佣金',
  dbi_revenue_scope_tip_excluding: '收入口径为SensorTower直接提供扣除渠道费（约30%）后的收入预估',
  dbi_revenue_scope_tip_including: '收入口径为未扣除渠道费的预估收入，按30%渠道费折算',
  dbi_download_settings_revenue_scope_tip: '收入口径与收入范围筛选器条件保持一致。',
  dbi_pcu_range: 'PCU区间',
  dbi_digital_revenue_range: 'MScience线上收入区间',
  dbi_physical_revenue_range: 'NPD零售收入区间',
  dbi_price_range: 'Steam付费游戏价格区间',
  dbi_minimum: '最小值',
  dbi_maximum: '最大值',
  dbi_revenue_growth: '收入增长率',
  dbi_revenue_error_format_tip: '输入错误，请检查格式。',
  dbi_number_range_two_decimal_tip: '最多保留两位小数。',
  dbi_less_than: '< 小于',
  dbi_greater_than: '> 大于',
  dbi_greater_than_equal: '≥ 大于等于',
  dbi_less_than_equal: '≤ 小于等于',
  dbi_equal_to: '= 等于',
  dbi_please_input: '请输入',
  dbi_input_range: '输入区间',
  dbi_cannot_be_null: `不能为空`,
  dbi_max_less_min: '最大值不能小于最小值',
  dbi_min_greater_max: '最小值不能大于最大值',
  dbi_input_growth: '输入增长率',
  dbi_input_overlap: '输入玩家重叠度',
  dbi_input_growth_percentage: '输入百分比',

  dbi_release_date: '发布时间',
  dbi_release: '发布时间',
  dbi_delete: '删除',
  dbi_disable: '禁用',

  dbi_download_chart: '下载图片',
  dbi_download_data: '下载数据',
  dbi_learnmore: 'Learn More',
  dbi_search_loading: '加载中...',
  dbi_search_empty: '暂无数据',
  dbi_search_no_result: '暂无数据',
  dbi_select_all: '全选',
  dbi_clear_all: '清空',
  dbi_data_privacy: '数据隐私',
  dbi_close: '关闭',
  dbi_data_privacy_got_it: '好的！',

  dbi_mobile: '手游',
  dbi_pc: 'PC游戏',
  dbi_console: '主机游戏',
  dbi_combine: '端游 & 主机游戏',
  dbi_pc_console_combine: '端游 & 主机游戏',
  dbi_console_version: '主机版本',
  dbi_single_country: '单一国家',
  dbi_multiple_countries: '多个国家',
  dbi_single_region: '单一区域',
  dbi_multiple_regions: '多个区域',
  dbi_country: '国家',
  dbi_region: '区域',
  dbi_select_region: '请选择区域',
  dbi_hot: '热门国家和区域',
  dbi_hot_metrics: '热门指标',
  dbi_ranking: '排行',
  dbi_quantity: '数量',
  dbi_country_region: '国家 / 地区',
  dbi_rank: '排行',
  dbi_rank_trend: '排行趋势',
  dbi_rank_loading: '排行加载中...',
  dbi_count: '计数',
  dbi_mentions: '声量',
  dbi_default_search_placeholder: '在表格内搜索任意游戏',
  dbi_table_search_placeholder: '在表格内搜索任意{domainName}',
  dbi_menu_search_placeholder: '搜索菜单',
  dbi_area_region: '区域',
  dbi_steam_id: 'SteamID',
  dbi_area_north_america: '北美',
  dbi_area_europe: '欧洲',
  dbi_label_search: '搜索',
  dbi_search_ranking_here: '在此搜索排行',
  dbi_hot_tags: '热门标签',
  dbi_hot_tags_placeholder: '选择任意标签',
  dbi_hot_tags_tooltip: '热门游戏分类，通过默认筛选部分筛选器得到游戏列表，有疑问可联系sallyxue',
  dbi_detail_trend: '趋势',
  dbi_cascader_placeholder: '选择任何平台',
  dbi_detail_user_engagement_ampere: '国家分布占比',
  dbi_detail_players_by_country: '玩家市场分布',
  dbi_composed_label_trends: '趋势',
  dbi_detail_price_trend: '价格趋势（美元）',
  dbi_detail_earliest_date: `最早有数据的日期`,
  dbi_detail_latest_date: `最后更新数据的日期`,
  dbi_detail_current_data_date: `当前数据时间`,
  dbi_detail_latestdate_info: '该数据截至更新于2025-07-01。由于SensorTower生命周期留存数据源已下架，后续该数据将不再更新。',
  dbi_detail_editions_share: `游戏版本占比`,
  dbi_detail_countries_share: `国家分布占比`,
  dbi_detail_global_data: `全球数据`,
  dbi_detail_pcu_and_acu: `PCU和ACU`,
  dbi_detail_channels_share: `渠道份额`,
  dbi_channel: `渠道`,
  dbi_offline: '已下架',
  dbi_inactive: '已停用',
  dbi_inactive_hover: '此应用程序在所有国家均处于非活跃状态。',
  dbi_offline_hover: '此应用已从商店中下架。',
  dbi_earliest_data: '最早数据',
  dbi_since_release: '自发布以来',

  // 国家列表相关
  dbi_global: '全球',
  dbi_world_wide: '全球',
  dbi_global_wo_china: '全球（不包括中国大陆）',
  dbi_total: 'Total',
  dbi_others: '其他',
  dbi_early_access: '抢先体验版',
  dbi_full_release: '正式版',
  dbi_off_line: '项目下线',
  dbi_beta: '公测版',
  dbi_alpha: '内测版',
  dbi_released: '正式版',
  dbi_cancelled: '项目取消',
  // 指标名，页签名
  dbi_active_users: '活跃用户',
  // dbi_active_users: '日活用户',
  dbi_revenue: '收入',
  dbi_ampere: 'Ampere',
  dbi_other_vendor: '其他数据源',
  dbi_revenue_$: '收入（美元）',
  dbi_downloads: '下载',
  dbi_rpd: 'RPD',
  dbi_retention: '留存',
  dbi_demographics: '用户画像',
  dbi_metrics_table: '指标表',
  dbi_pcu: 'PCU',
  dbi_mscience: 'Mscience',
  dbi_xbox_upcoming: 'Xbox 即将上市',
  dbi_digital_revenue: '线上收入',
  dbi_digital_revenue_$: '线上收入（美元）',
  dbi_digital_revenue_$_only_us: '付费玩家人均线上消费额(美元)(仅美国)',
  dbi_physical_revenue: '零售收入',
  dbi_japan_sales: '日本销售额',
  dbi_steam_sales: 'Steam销售额',
  dbi_mau: '月活跃玩家数',
  dbi_wau: '周活跃玩家数',
  dbi_dau: '日活跃玩家数',
  dbi_lifetime_players: '总注册数',
  dbi_new_release: '新发布游戏',
  dbi_upcoming: '即将发布游戏',
  dbi_benchmark: '标杆游戏',
  dbi_acu: 'ACU',
  // dbi_newzoo_metrics: '活跃',
  dbi_newzoo_metrics: 'No-Update',
  dbi_ampere_metrics: '活跃',
  dbi_monthly_retention: '月度留存',
  dbi_lifetime_retention: '生命周期留存',
  dbi_lifetime_retention_tips: '仅提供全球数据和历史数据，您可以显示无粒度限制的数据。',
  dbi_overview: '概览',
  dbi_gameinfo: '游戏基础信息',
  dbi_kpi_overview: 'KPI概览',
  dbi_kpi_trends: 'KPI趋势',
  dbi_kpi_trends_jump: '更多游戏指标可查看',
  dbi_stats: '数据',
  dbi_insights: '洞察',
  dbi_countries: '国家/地区',
  dbi_storeRank: '商店排行',
  dbi_overlap: '游戏重叠度',
  dbi_steam_overlap: '游戏重叠度',
  dbi_opinions: '舆情',
  dbi_streaming: '直播',
  dbi_data_report: '数据报告',
  dbi_dataBrain_calibration: 'DataBrain 校准',
  'Total Revenue($)': '总收入($)',
  'Lifetime Total Revenue($)': '历史总收入($)',
  'Base Game Sales Units': '游戏本体销量',
  'Lifetime Base Game Sales Units': '游戏本体历史总销量',
  dbi_us_only: `仅供美国数据`,
  dbi_japan_only: '仅供日本数据',
  dbi_global_only: `仅供全球数据`,
  dbi_pcu_steam_only: `仅Steam平台数据`,
  dbi_steam_only: '仅提供Steam平台和全球数据',
  dbi_change: '变化',
  dbi_rank_change: '排名变化',
  dbi_download_language: '语言',
  dbi_download_language_option_cn: '中文',
  dbi_download_language_option_en: '英文',
  dbi_detail_games_share: `游戏占比`,
  dbi_description: '描述',

  dbi_no_data: '无匹配项',
  dbi_data_preview: '数据预览',
  dbi_no_data_available: '所选内容下没有可用数据。',
  dbi_no_available: '没有可用数据',
  dbi_no_data_available_gsd: 'GSD提供欧洲国家销售数据，仅周粒度更新。',
  dbi_no_data_available_store_rank: '该游戏未上榜此Steam榜单',
  dbi_no_data_available_top_100_seller_rank: '该游戏未进入Steam畅销榜前100',
  dbi_no_data_available_store_rank_daily_only: '该榜单为日粒度更新，周/月粒度不可用。',
  dbi_manage: '管理',
  dbi_current_games: '现有游戏',
  dbi_newrelease_upcominggames: '新发布和即将发布游戏',
  dbi_heat_range: '潜力值范围',
  dbi_arpu: '活跃ARPU',
  dbi_search_for_source: '搜索数据源',
  dbi_search_for_metrics: '搜索指标',
  dbi_filter_segment: '产品分类',
  dbi_ai_hub_reports: 'AI 专区报告',
  dbi_ai_hub_reports_intro: '在这里，我们为你呈现 AI 相关的行业洞察与产品演示视频。',
  dbi_ai_hub_reports_search: '搜索 AI 报告',
  dbi_ai_hub_reports_game_ai: '游戏AI',
  dbi_ai_hub_reports_ai_assets: 'AI素材',
  dbi_filter_segment_engagement: '参与度',
  dbi_filter_segment_engagement_two_a: '游戏A游玩时长',
  dbi_filter_segment_engagement_two_b: '游戏B游玩时长',
  dbi_filter_segment_engagement_two_b_level: '游戏B游玩时长',
  dbi_filter_group_popular: '热门筛选',
  dbi_filter_group_company: '公司',
  // Performance Summary & Edition List tooltips
  dbi_performance_summary_tip: '点击上方"数据"，可查看 {sensorTower} Sensor Tower更多详情数据。',
  dbi_edition_list_tip: '各项指标的统计周期跟随顶部数据卡片所选时间范围联动更新。',
  dbi_filter_group_game_performance: '游戏表现',
  dbi_filter_group_sensor_tower: 'Sensor Tower',
  dbi_filter_group_app_magic: 'App Magic',
  dbi_filter_group_igdb: 'IGDB',
  dbi_filter_group_mscience: 'Mscience',
  dbi_filter_group_steam: 'Steam',
  dbi_filter_group_gsd: 'GSD',
  dbi_filter_group_npd: 'NPD',
  dbi_wishlists_range: 'Wishlists区间',
  dbi_segment_lte_2h: '小于等于2小时',
  dbi_segment_greater_2h: '大于2小时',
  dbi_segment_greater_10h: '大于10小时',
  dbi_segment_greater_20h: '大于20小时',
  dbi_segment_greater_50h: '大于50小时',
  dbi_segment_greater_100h: '大于100小时',
  dbi_segment_greater_200h: '大于200小时',
  dbi_region_segment_global: 'Global',
  dbi_region_segment_na: '美国&加拿大',
  dbi_region_segment_chn: '中国',
  dbi_region_segment_asia: '亚洲（不包括中国）',
  dbi_region_segment_we: '西欧',
  dbi_region_segment_ee: '东欧',
  dbi_region_segment_others: '其他',
  dbi_region_segment_btnname: '地区/国家',
  dbi_segment_rank_trend: '国家排名趋势',
  dbi_segment_market_count: '市场份额分布',
  dbi_switch_align_to_release: '对齐上线时间',
  dbi_segment_rank_trend_avg_ranking_tips: '平均排名计算仅包括排名前500名的游戏',
  dbi_segment_avg_ranking: '平均排名',
  dbi_segment_latest_ranking_filtered: '截止日排名',
  dbi_retention_curve: '留存曲线',
  dbi_label_new_release_games: '新发布游戏',
  dbi_label_upcoming_games: '即将发布游戏',
  dbi_label_mobile_games: '手游',
  dbi_label_pc_games: '端游',
  dbi_label_console_games: '主机游戏',
  dbi_global_initial_launch: '全球首发',
  dbi_new_market_entry: '新市场进入',
  dbi_please_select_metrics: '请选择指标',
  dbi_all_metrics: '全部指标',
  dbi_combine_console_data: 'Alinea Analytics 数据',
  dbi_storage_required: '安装空间要求',
  dbi_genre_main: '主',
  dbi_genre_sub: '子',
  dbi_release_date_by_platform: '各平台的发行日期',
  dbi_release_date_full_release: '上线时间',
  dbi_release_date_new: '上线时间',
  dbi_release_region: '地区',
  dbi_release_phase: '发行阶段',
  dbi_date_joined_xbox_game_pass: '加入Xbox Game Pass的时间',
  dbi_game_languages: '游戏语言',
  dbi_select_any_tag: '选择任意标签',
  dbi_common_data_from_tips: '{metric}数据来源于{dataSource}。',
  dbi_metric_dataof_generatedby: '{sourceName}数据来源于 ',
  dbi_metric_table_head_datasource: '数据来源： ',
  // dbi_metric_dataof_generatedby_suf: ' 内部。',
  dbi_metric_dataof_generatedby_suf: ' ',
  dbi_metric_data_of_generated_by: '原始数据来源于 {steam} 公开的玩家游戏库。',
  dbi_by_device: '按设备',
  dbi_separate_by_device: '分设备',
  dbi_pc_console_download_by_device_tip: 'Mscience和Alinea Analytics无设备数据，下载仅展示平台信息',
  dbi_by_platform: '按平台',
  dbi_avg_mau: '平均月活',
  dbi_total_reviews: '总评论数',
  dbi_data: '数据',
  dbi_unfollow_goto_manage: '如果需要取关该游戏，请前往Manage页。',
  dbi_countries_pcu: `PCU和ACU全球数据`,
  dbi_countries_digital: `线上收入国家分布占比`,
  dbi_countries_physical: `零售收入国家分布占比`,
  dbi_trends_digital: `线上收入趋势`,
  dbi_trends_physical: `零售收入趋势`,
  dbi_countries_japansales: `日本销售额趋势`,
  dbi_trends_japansales: `日本销售额趋势`,
  dbi_trends_pcu: `PCU趋势`,
  dbi_trends_gsd: `GSD销售数据趋势`,
  dbi_countries_gsd: `GSD销售数据国家分布占比`,

  dbi_cross_mobile_usage: `跨应用使用情况`,
  dbi_cross_mobile_affinity: `跨应用亲和度`,
  dbi_selected_multiple_months: `可以选择多个月份，数据还是以单月份导出`,
  dbi_selected_multiple_country: `可以选择多个国家，数据还是以单国家导出`,
  dbi_game_detail_countries: '国家',
  dbi_game_detail_region: '区域',
  dbi_selector_game_type: '游戏类型',
  dbi_selector_game_type_label: '类型',
  dbi_type: '类型',
  dbi_cancel_prohibited: '禁止取消',
  dbi_game_comparison_table: '游戏对比表格',

  MScience: 'MScience',
  GSD: 'GSD',
  NPD: 'NPD',
  DataBrain: 'DataBrain',
  dbi_segment_rank_trend_avg_ranking_tips_title: '平均排名计算只包括 -',
  dbi_segment_rank_trend_avg_ranking_tips_appstore: 'Appstore：免费榜和付费榜排名前500的游戏，收入榜排名前200的游戏',
  dbi_segment_rank_trend_avg_ranking_tips_googlePlay: 'Google Play：免费榜，付费榜和收入榜前50的游戏',

  dbi_segment_rank_trend_avg_ranking_tips_title_combine: '平均排名计算只包括各商店榜单能爬取到的范围，例：',
  dbi_segment_rank_trend_avg_ranking_tips_title_combine_steam_top_seller: 'Steam Top Seller榜单爬取排名前6648的游戏',
  dbi_segment_rank_trend_avg_ranking_tips_title_combine_epic_top_seller: 'Epic Games Top seller榜单爬取排名前100的游戏',
  dbi_segment_rank_trend_avg_ranking_tips_title_combine_playStation_best_selling:
    'PlayStation Best Selling榜单爬取排名前9984的游戏',
  dbi_segment_rank_trend_avg_ranking_tips_title_combine_xbox_best_rated: 'Xbox Best Rated榜单爬取排名前1000的游戏',
  dbi_segment_rank_trend_avg_ranking_tips_title_combine_nintendo_best_seller:
    'Nintendo Best Seller榜单爬取排名前243的游戏',

  dbi_segment_rank_trend_dod: '日环比',
  dbi_segment_rank_trend_period: '周期环比',
  dbi_segment_rank_trend_dod_desc: '展示对比前一天的排名趋势',
  dbi_segment_rank_trend_period_desc: '展示对比上个周期最后一天的排名趋势',
  dbi_segment_rank_trend_avg: '平均排名趋势',

  dbi_data_ai_no_update_tip:
    // '因{SensorTower}已收购{DataAi}，{DataAi}的数据将于2024年11月起不再更新，保留历史数据。后续手游数据请参考{SensorTower}，DataBrain将及时更新{SensorTower}平台的任何数据刷新确保与平台数据一致。',
    '因Sensor Tower已收购data.ai，data.ai的数据将于2024年11月起不再更新，保留历史数据。后续手游数据请参考Sensor Tower，DataBrain将持续更新Sensor Tower平台数据。我们在11月初，新增了挪威、罗马尼亚等国家日周月的数据拉取，月粒度数据目前已回补至17年，但日周粒度数据调取量较大，还在规划方案中。',

  dbi_only_data_ai_no_update_tip:
    // '因{SensorTower}已收购{DataAi}，{DataAi}的数据将于2024年11月起不再更新，保留历史数据。后续手游数据请参考{SensorTower}。',
    '因Sensor Tower已收购data.ai，data.ai的数据将于2024年11月起不再更新，保留历史数据。后续手游数据请参考Sensor Tower。',
  dbi_sensor_tower_data_model_update_tip:
    'DataBrain于25年8月18日切换为Sensor Tower新数据模型（融合data.ai），提供自2012年起的手游收入、下载量和活跃数据。',
  'Steam All Reviews': 'Steam全部评论',
  'Steam All Reviews Positive%': 'Steam全部评论好评占比',
  'Steam Added Positive%': 'Steam新增评论好评占比',
  dbi_store_rank_download_tips_title: '可支持多日下载',
  dbi_store_rank_region_filter_top_sellers_only: '区域筛选仅适用于热销榜',
  dbi_public_data_entityType: '游戏类型',
  dbi_download_modal_stick_tips: '下载文件最多支持10万行。',
  dbi_mobile_download_modal_stick_tips:
    '下载文件最多支持10万行。例如Top150游戏月粒度下选择6个月分时间分国家下载，数据最大将会是150*6*113=101,700行。',
  dbi_country_flter_applies: '国家筛选器仅作用于热销榜。',
  dbi_current_storeRank_nodata_global: '该榜单仅选择范围为全球时可用。',
  dbi_only_global_rankings: '该商店榜单只有全球排名，没有分国家排名',
  dbi_only_global_rankings_epic: 'Epic商店只有全球榜单，没有分国家榜单',

  dbi_by_region: '按地区',
  dbi_by_country: '按国家',
  dbi_shortcut: '快捷键',
  dbi_date_range: '时间范围',

  dbi_calculation_method_average: '取均值',

  // App Magic Tag 筛选器
  dbi_appmagic_themes: '主题',
  dbi_appmagic_features: '玩法特点',
  dbi_appmagic_ip: 'IP',
  dbi_appmagic_settings: '设定',
  dbi_appmagic_art_styles: '美术风格',

  // Game Comparison Feature
  dbi_game_comparison: '游戏对比',
  dbi_game_comparison_tooltip: '跳转至游戏对比页面，将当前游戏与竞品对比。',
  dbi_vs_button_tooltip: '跳转至游戏对比页面，将当前游戏与以下竞品进行对比。',
  dbi_compare_competitors: '对比竞品',
  dbi_worldwide_update_time: '每天UTC+8   12:00更新',
  dbi_worldwide_tab_steam: 'Steam',
  dbi_worldwide_tab_roblox: 'Roblox',
  dbi_worldwide_mobile_breakouts: '手游异动',
  dbi_worldwide_mobile_tip_new_label: '新上线：',
  dbi_worldwide_mobile_tip_new_desc: '7日内上线,且进入Appstore收入榜Top50。',
  dbi_worldwide_mobile_tip_surge_label: '突增：',
  dbi_worldwide_mobile_tip_surge_desc: 'Appstore收入榜1–5 名较前一日上升≥5 名、6–20名上升≥10 名、21–50名上升≥20 名的游戏。',
  dbi_worldwide_grossing: '收入榜',
  dbi_worldwide_grossing_upper: '收入榜',
  dbi_worldwide_steam_breakouts: 'Steam异动',
  dbi_worldwide_steam_tip_new_desc: '过去24h Steam PCU 前 20，且 T‑7 日内新发行的游戏。',
  dbi_worldwide_steam_tip_surge_desc: 'Steam PCU 排名前 10，较前一日名次上升 ≥ 5的游戏。',
  dbi_worldwide_steam_anomaly_title: '异动分析',
  dbi_worldwide_steam_pcu_source: 'Steam PCU数据来源于Steamdb，根据更新时间过去24h计算。',
  dbi_worldwide_steam_hot_games: '热门游戏',
  dbi_worldwide_steam_pcu_24h: '近24小时PCU',
  dbi_worldwide_steam_change: '变化量',
  dbi_worldwide_steam_release_days: '上线天数',
  dbi_worldwide_days_unit: '天',
  dbi_worldwide_game_release: 'Game Release:',
  dbi_worldwide_iegg_genre: 'IEGG品类',
  dbi_worldwide_roblox_breakouts: 'Roblox异动',
  dbi_worldwide_roblox_tip_new_desc: '首次进入Roblox CCU Top10的游戏。',
  dbi_worldwide_roblox_tip_surge_desc: '最近一年未上榜，新进入Roblox CCU Top10的游戏。',
  dbi_worldwide_roblox_hot_games: '热门游戏',
  dbi_worldwide_roblox_ccu_24h: '近24小时CCU',
  dbi_worldwide_roblox_change: '变化量',
  dbi_worldwide_roblox_release_days: '上线天数',
  dbi_worldwide_roblox_gameplay: '玩法',
  dbi_worldwide_roblox_social: '社交',
  dbi_worldwide_roblox_theme: '题材',
  dbi_worldwide_roblox_rng: 'RNG',
  dbi_worldwide_roblox_elements: '游戏元素',
  dbi_worldwide_roblox_gameplay_tip: 'Roblox游戏玩法标签来源于游戏研究中心，专家基于Roblox游戏综合评估后，提供的标签体系。',
  dbi_worldwide_roblox_elements_tip: 'Roblox游戏元素标签来源于游戏研究中心，专家基于Roblox游戏综合评估后，提供的标签体系。',
  dbi_worldwide_roblox_ccu_source: 'Roblox游戏CCU数据来源为采集官网在线数量，每10分钟采集一次。',
  dbi_reuse_page_title_roblox_game_rank: 'Roblox游戏榜单',
  dbi_reuse_page_title_roblox_top_charts: 'Roblox排行榜',
  dbi_roblox_device: '设备',
  dbi_roblox_device_option_all: '全部设备',
  dbi_roblox_device_option_console: '游戏主机',
  dbi_roblox_device_option_computer: '电脑',
  dbi_roblox_device_option_entry_level_phone: '入门级手机',
  dbi_roblox_device_option_entry_level_tablet: '入门级平板',
  dbi_roblox_device_option_standard_phone: '标准版手机',
  dbi_roblox_device_option_standard_tablet: '标准版平板',
  dbi_roblox_device_option_vr: '虚拟现实(VR)设备',
  dbi_roblox_up_date: '更新时间',
  dbi_roblox_genre: 'Roblox品类',
  dbi_roblox_server_size: '服务器大小',
  dbi_roblox_supported_features: '支持功能',
  dbi_roblox_support_feature_voice_chat: '语音聊天',
  dbi_roblox_support_feature_camera: '相机',
  dbi_roblox_top_charts_metric_pcu: 'PCU',
  dbi_roblox_top_charts_metric_players: '玩家数',
  dbi_roblox_top_charts_metric_visits: '访问数',
  dbi_roblox_top_charts_metric_likes: '点赞数',
  dbi_roblox_top_charts_metric_dislikes: '点踩数',
  dbi_roblox_top_charts_metric_favorites: '收藏数',
  dbi_roblox_top_charts_metric_section_title: 'Metric',
  dbi_roblox_top_charts_sorted_by: '按Roblox {sortField}排序',
  dbi_roblox_top_charts_sort_field_ccu: 'Roblox CCU',
  dbi_roblox_game_rank_section_title: '排名',
  dbi_roblox_game_rank_sorted_by: '按{sortField}排序',
  dbi_roblox_game_rank_sort_field: '#rank',
  dbi_roblox_rank_list: '榜单',
  dbi_roblox_download_game_info: '游戏信息',
  dbi_roblox_download_classification: '分类',
  dbi_roblox_download_rank_selected_count: '已选 {count} 个榜单',
  dbi_roblox_download_search: '搜索',
  dbi_roblox_rank_category_popular: '热度',
  dbi_roblox_rank_category_genres: '品类',
  dbi_roblox_rank_category_earnings: '变现',
  dbi_roblox_rank_category_featured: '精选',
  dbi_roblox_rank_source_most_popular: '人气总榜',
  dbi_roblox_rank_source_top_playing_now: '当前热玩榜',
  dbi_roblox_rank_source_top_trending: '热门飙升榜',
  dbi_roblox_rank_source_up_and_coming: '新秀崛起榜',
  dbi_roblox_rank_source_fun_with_friends: '好友同乐榜',
  dbi_roblox_rank_source_trending_music_experiences: '音乐体验飙升榜',
  dbi_roblox_rank_source_trending_in_rpg: '角色扮演类飙升榜',
  dbi_roblox_rank_source_trending_in_sports_racing: '体育竞速类飙升榜',
  dbi_roblox_rank_source_trending_in_shooter: '射击类飙升榜',
  dbi_roblox_rank_source_trending_in_action: '动作类飙升榜',
  dbi_roblox_rank_source_trending_in_adventure: '冒险类飙升榜',
  dbi_roblox_rank_source_trending_in_entertainment: '娱乐类飙升榜',
  dbi_roblox_rank_source_trending_in_obby_platformer: '平台跳跃类飙升榜',
  dbi_roblox_rank_source_trending_in_party_casual: '派对休闲类飙升榜',
  dbi_roblox_rank_source_trending_in_puzzle: '解谜类飙升榜',
  dbi_roblox_rank_source_trending_in_roleplay_avatar_sim: '角色扮演与形象模拟类飙升榜',
  dbi_roblox_rank_source_trending_in_shopping: '购物类飙升榜',
  dbi_roblox_rank_source_trending_in_simulation: '模拟经营类飙升榜',
  dbi_roblox_rank_source_trending_in_strategy: '策略类飙升榜',
  dbi_roblox_rank_source_trending_in_survival: '生存类飙升榜',
  dbi_roblox_rank_source_top_earning: '高额创收榜',
  dbi_roblox_rank_source_top_paid_access: '付费体验榜',
  dbi_roblox_rank_source_more_when_you_subscribe: '订阅解锁更多',
  dbi_roblox_rank_source_top_rated: '高分好评榜',
  dbi_roblox_rank_source_top_revisited: '经典回访榜',
  dbi_roblox_rank_source_learn_and_explore: '学习与探索',
  dbi_roblox_rank_source_most_popular_desc:
    '按日活跃用户数量排序；上榜游戏需满足日活≥5000、日活排名前 10% 或游玩热度前 30。榜单排序会受页面设备、地区筛选条件影响。',
  dbi_roblox_rank_source_top_playing_now_desc: '按同时在线游玩人数排序的热门游戏',
  dbi_roblox_rank_source_top_trending_desc: '过去一周日活跃用户相对涨幅最高的游戏',
  dbi_roblox_rank_source_up_and_coming_desc: '近 28 天内上线、用户增长表现最佳的游戏',
  dbi_roblox_rank_source_fun_with_friends_desc:
    '日活不低于 5000 的游戏，按好友组队游玩时长占比排序；上榜游戏需满足日活≥5000、日活排名前 10% 或游玩热度前 30。榜单排序会受页面设备、地区筛选条件影响。',
  dbi_roblox_rank_source_trending_music_experiences_desc:
    '日活不少于 2500 的音乐类游戏，取近两周游玩时长相对涨幅最高的作品',
  dbi_roblox_rank_source_trending_in_rpg_desc: '过去一周日活跃用户相对涨幅最高的 RPG 角色扮演类游戏',
  dbi_roblox_rank_source_trending_in_sports_racing_desc:
    '过去一周日活跃用户相对涨幅最高的体育竞速类游戏',
  dbi_roblox_rank_source_trending_in_shooter_desc: '过去一周日活跃用户相对涨幅最高的射击类游戏',
  dbi_roblox_rank_source_trending_in_action_desc: '过去一周日活跃用户相对涨幅最高的动作类游戏',
  dbi_roblox_rank_source_trending_in_adventure_desc: '过去一周日活跃用户相对涨幅最高的冒险类游戏',
  dbi_roblox_rank_source_trending_in_entertainment_desc:
    '过去一周日活跃用户相对涨幅最高的休闲娱乐类游戏',
  dbi_roblox_rank_source_trending_in_obby_platformer_desc:
    '过去一周日活跃用户相对涨幅最高的障碍跑酷 & 平台跳跃类游戏',
  dbi_roblox_rank_source_trending_in_party_casual_desc:
    '过去一周日活跃用户相对涨幅最高的派对 & 轻休闲类游戏',
  dbi_roblox_rank_source_trending_in_puzzle_desc: '过去一周日活跃用户相对涨幅最高的解谜类游戏',
  dbi_roblox_rank_source_trending_in_roleplay_avatar_sim_desc:
    '过去一周日活跃用户相对涨幅最高的角色扮演 & 虚拟形象模拟类游戏',
  dbi_roblox_rank_source_trending_in_shopping_desc: '过去一周日活跃用户相对涨幅最高的购物模拟类游戏',
  dbi_roblox_rank_source_trending_in_simulation_desc:
    '过去一周日活跃用户相对涨幅最高的模拟经营类游戏',
  dbi_roblox_rank_source_trending_in_strategy_desc: '过去一周日活跃用户相对涨幅最高的策略类游戏',
  dbi_roblox_rank_source_trending_in_survival_desc: '过去一周日活跃用户相对涨幅最高的生存类游戏',
  dbi_roblox_rank_source_top_earning_desc:
    '按近 7 天总 Robux 消费金额排序；上榜游戏需满足日活≥5000、日活排名前 10% 或游玩热度前 30。榜单排序会受页面设备、地区筛选条件影响。',
  dbi_roblox_rank_source_top_paid_access_desc: '付费解锁类游戏，按单日收入排序',
  dbi_roblox_rank_source_more_when_you_subscribe_desc:
    '日活不少于 5000 人的游戏，按付费订阅用户游玩时长排序',
  dbi_roblox_rank_source_top_rated_desc:
    '日活不低于 5000、点赞总量与点赞占比均表现优异的游戏',
  dbi_roblox_rank_source_top_revisited_desc:
    '按一周后回访用户占比排序；上榜游戏需满足日活≥5000、日活排名前 10% 或游玩热度前 30。榜单排序会受页面设备、地区筛选条件影响。',
  dbi_roblox_rank_source_learn_and_explore_desc:
    '包含学习向内容，能够激发玩家创造力与批判性思维的游戏',
  dbi_worldwide_new_entry: '新进榜',
  dbi_worldwide_tag_new: '新上榜',
  dbi_worldwide_tag_surge: '突增',
  dbi_worldwide_contact_text: '有问题请联系delvinding或velvetjiang',
  dbi_less: '收起',
};
